<div>
    <p-calendar
        [(ngModel)]="durationAsDate"
        (onBlur)="setDurationLength()"
        timeOnly="true"
        appendTo="body"
        [showTime]="true"
    ></p-calendar>
</div>